import { Card, CardContent } from '@material-ui/core'
import React from 'react'
import Background from 'assets/images/HR-Background.jpg'
import { useHistory, useLocation } from 'react-router'
import { useCheckQrExpiryQuery } from 'generated/graphql'
import queryString from 'query-string'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'

export const EInvoiceBuyerDetailCompleted = () => {
  const location = useLocation()
  let history = useHistory()
  const debtorInfo = queryString.parse(location.search)

  const {
      loading: CheckQRExpiryLoading
    } = useCheckQrExpiryQuery({
      variables: {
        HotelID: debtorInfo.HotelID as string || JSON.parse(localStorage.getItem('Hotel'))?.ID,
        FloatingID: debtorInfo.FolioID as string,
        Module: debtorInfo.Module ? (debtorInfo.Module as string).trim().replace(/[^a-zA-Z]/g, '') : null,
        DocType: (debtorInfo.Module as string).trim().replace(/[^a-zA-Z]/g, '') === 'CityAccount' 
          ? 'INV'
          : null
      },
      onCompleted: ({ CheckQRExpiry }) => {
        if (CheckQRExpiry === true) {
          setTimeout(() => { 
            history.push(`/buyer-detail-expired?HotelID=${debtorInfo.HotelID as string}&FloatingID=${debtorInfo.FolioID as string}`)
          }, 1000)
        }
      },
      fetchPolicy: 'no-cache'
    })

  return (
    <>
      {CheckQRExpiryLoading && <Loading/>}
      <div
        className='einv-layout-completed'
        style={{
          background: 'url("' + Background + '") no-repeat center center fixed'
        }}
      >
        <div className='form-box' style={{ marginTop: '120px' }}>
          <span
            style={{
              fontFamily: 'Poppins, sans-serif',
              color: "#FFFFFF",
              fontWeight: 700,
              fontSize: '15px',
              display: 'flex', 
              justifyContent: 'center',
              alignItems: 'center',
              padding: '5px 0',
              marginBottom: '4px'
            }}
          >
            e-Invoice Buyer Details Completed
          </span>
          <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: '2px'}}>
            <Card
              style={{
                margin: '5px 0',
                borderRadius: '5px', 
                width: '90%'
              }}
            >
              <CardContent>
                <span
                  style={{
                    fontFamily: 'Poppins, sans-serif',
                    color: "#000000",
                    fontWeight: 700,
                    fontSize: '14px',
                    display: 'flex', 
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '1px',
                    marginTop: '5px'
                  }}
                >
                  Your details have been updated. Please inform cashier to proceed. Thank you!
                </span>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </>
  )
}